export default {
  verboseName: "Prenotazione",
  verboseNamePlural: "Prenotazioni",
  modelName: "Booking",
  modelNamePlural: "Bookings",
  appName: "bookings",
  propName: "booking",
  propNamePlural: "bookings",
}
